<template>
  <div class="component item-list-summary summary-default">
    <div class="image-container">
      <img :src="item.imageUrl" alt="" class="image">
    </div>
    <div class="info">
      <div class="name">{{ item.name }}</div>
      <div class="detail">
        <div class="icons">
          <span class="time" v-if="item.listStartTime">{{ $formatter.time(item.listStartTime) }}</span>
          <duration v-if="item.hasDuration" :hours="item.durationHours" :minutes="item.durationMinutes"/>
        </div>
        <div class="price" v-if="item.listPrice">{{ $formatter.currency(item.listPrice) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Duration from '@/components/Duration.vue';

export default {
  props: ['item'],
  components: { Duration }
}
</script>

<style lang="scss">

.component.summary-default {
  box-shadow: 0 1px 5px 1px rgba(0,0,0,0.2);
  color: #222;
  height: 100%;
  background-color: #fff;

  .image-container {
    height: 0;
    overflow: hidden;
    background: #fff;
    position: relative;
    width: 100%;
    padding-top: 56.25%;
  }

  .image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .info {
    padding: 15px;
  }

  .name {
    @include font-h3;
    margin-bottom: 5px;
  }

  .detail {
    display: flex;
    justify-content: space-between;

    @include breakpoint(medium) {
      display: block;
    }
  }

  .icons {
    @include item-list-icons;
  }

  .price {
    @include font-h2;

    @include breakpoint(medium) {
      text-align: right;
    }

    .from {
      @include from;
      margin-right: 5px;
    }
  }
}
</style>